module.exports = __webpack_public_path__ + "img/other-bg-square.af066eb8.webp";